export interface INavigationRoute {
  name: string
  displayName: string
  meta?: { icon?: string; allowParentLink?: boolean }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'reference-design',
      displayName: 'menu.projects',
      meta: {
        icon: 'folder_shared',
        allowParentLink: true,
      },
      children: [
        {
          name: 'resources',
          displayName: 'menu.resources',
        },
      ],
    },
    {
      name: 'solution-templates',
      displayName: 'menu.solution-templates',
      meta: {
        icon: 'design_services',
        allowParentLink: true,
      },
      children: [
        {
          name: 'applications',
          displayName: 'menu.applications',
        },
        {
          name: 'templates',
          displayName: 'menu.templates',
        },
      ],
    },
    {
      name: 'evaluation-kits',
      displayName: 'menu.evaluation-kits',
      meta: {
        icon: 'developer_board',
      },
    },
    {
      name: 'software-projects',
      displayName: 'menu.software-projects',
      meta: {
        icon: 'code',
        allowParentLink: true,
      },
      children: [
        {
          name: 'toolchains',
          displayName: 'menu.toolchains',
        },
      ],
    },
    // {
    //   name: 'dashboard',
    //   displayName: 'menu.dashboard',
    //   meta: {
    //     icon: 'vuestic-iconset-dashboard',
    //   },
    // },
    {
      name: 'background',
      displayName: 'menu.background',
      meta: {
        icon: 'analytics',
      },
    },
    {
      name: 'devops',
      displayName: 'menu.devops',
      meta: {
        icon: 'engineering',
      },
      children: [
        {
          name: 'solution-template-audit',
          displayName: 'menu.audit',
          meta: {
            icon: 'fact_check',
          },
        },
        {
          name: 'export',
          displayName: 'menu.export',
          meta: {
            icon: 'file_download',
          },
        },
        {
          name: 'import',
          displayName: 'menu.import',
          meta: {
            icon: 'file_upload',
          },
        },
        {
          name: 'upgrade-schema',
          displayName: 'menu.upgrade-schema',
        },
      ],
    },
    {
      name: 'upgrade-index',
      displayName: 'menu.upgrade-index',
      meta: {
        icon: 'upgrade',
        allowParentLink: true,
      },
      children: [
        {
          name: 'upgrade-index-reference-design',
          displayName: 'menu.reference-design',
        },
        {
          name: 'upgrade-index-audit',
          displayName: 'menu.audit',
        },
      ],
    },
    // {
    //   name: 'reference-design-detail',
    //   displayName: 'menu.project-detail',
    //   meta: {
    //     icon: 'folder_shared',
    //   },
    // },
    // {
    //   name: 'auth',
    //   displayName: 'menu.auth',
    //   meta: {
    //     icon: 'login',
    //   },
    //   children: [
    //     {
    //       name: 'login',
    //       displayName: 'menu.login',
    //     },
    //     {
    //       name: 'signup',
    //       displayName: 'menu.signup',
    //     },
    //     {
    //       name: 'recover-password',
    //       displayName: 'menu.recover-password',
    //     },
    //   ],
    // },
    // {
    //   name: '404',
    //   displayName: 'menu.404',
    //   meta: {
    //     icon: 'vuestic-iconset-files',
    //   },
    // },
    {
      name: 'preferences',
      displayName: 'menu.preferences',
      meta: {
        icon: 'manage_accounts',
      },
    },
  ] as INavigationRoute[],
}
